export const LOW = 'LOW';
export const MID = 'MID';
export const HIGH = 'HIGH';
